import { useState } from 'react';
import { IPricePoliciesEntity } from '../../../../Services/api/price-policies/price-policies.interface';

interface UseSelectPricePoliciesProps {
    multiple?: boolean;
    onSelect?: (policies: IPricePoliciesEntity[]) => void;
    initialSelected?: IPricePoliciesEntity[];
}

export const useSelectPricePolicies = ({
    multiple = true,
    onSelect,
    initialSelected = []
}: UseSelectPricePoliciesProps = {}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedPolicies, setSelectedPolicies] = useState<IPricePoliciesEntity[]>(initialSelected);

    const openModal = () => {
        setIsOpen(true);
    };

    const closeModal = () => {
        setIsOpen(false);
    };

    const handleSelect = (policies: IPricePoliciesEntity[]) => {
        setSelectedPolicies(policies);
        onSelect?.(policies);
        setIsOpen(false);
    };

    const clearSelection = () => {
        setSelectedPolicies([]);
        onSelect?.([]);
    };

    const addPolicy = (policy: IPricePoliciesEntity) => {
        if (multiple) {
            const isAlreadySelected = selectedPolicies.some(p => p.id === policy.id);
            if (!isAlreadySelected) {
                const newSelection = [...selectedPolicies, policy];
                setSelectedPolicies(newSelection);
                onSelect?.(newSelection);
            }
        } else {
            setSelectedPolicies([policy]);
            onSelect?.([policy]);
        }
    };

    const removePolicy = (policyId: string) => {
        const newSelection = selectedPolicies.filter(p => p.id !== policyId);
        setSelectedPolicies(newSelection);
        onSelect?.(newSelection);
    };

    const isSelected = (policyId: string) => {
        return selectedPolicies.some(p => p.id === policyId);
    };

    return {
        isOpen,
        selectedPolicies,
        openModal,
        closeModal,
        handleSelect,
        clearSelection,
        addPolicy,
        removePolicy,
        isSelected,
        selectedCount: selectedPolicies.length,
        hasSelection: selectedPolicies.length > 0
    };
};
